import React from 'react'
// import Data
import { TeamDatas } from './data'
const TeamArea = () => {

return (
    <>
        <section
            id="volunteer_area_main"
            className="section_pdding d-flex justify-content-center"
            style={{
                padding: '60px 5%',
                backgroundColor: '#FCFCFC',
                marginLeft: '2%',
            }}
        >
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center mb-5">
                        <div className="section_title">
                            <h2 className="section_heading" style={{ fontSize: '2rem' }}>
                                The Cradle Care Team
                            </h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {TeamDatas.map((data, index) => (
                        <div
                            className="col-12 col-sm-6 col-md-4 mb-4 d-flex justify-content-center"
                            key={index}
                        >
                            <div className="volunteer_wrapper text-center">
                                <div
                                    className="volunteer_img mx-auto"
                                    style={{
                                        width: '300px',
                                        height: '300px',
                                        borderRadius: '50%',
                                        overflow: 'hidden',
                                        border: '4px solid #ddd',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0 auto',
                                    }}
                                >
                                    <img
                                        src={data.img}
                                        alt="img"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            borderRadius: '50%',
                                        }}
                                    />
                                </div>
                                <div className="volunteer_text mt-3" style={{ textAlign: 'center' }}>
                                    <h3 style={{ fontSize: '1.5rem' }}>
                                        <a href="#!">{data.name}</a>
                                    </h3>
                                    <p>{data.title}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
        <style>
            {`
                @media (max-width: 768px) {
                    .section_pdding {
                        padding: 40px 2%;
                    }
                    .volunteer_img {
                        width: 120px !important;
                        height: 120px !important;
                    }
                }
                @media (max-width: 576px) {
                    .section_pdding {
                        padding: 20px 1%;
                    }
                    .volunteer_img {
                        width: 200px !important;
                        height: 200px !important;
                    }
                    .section_heading {
                        font-size: 1.2rem !important;
                    }
                }
            `}
        </style>
    </>
)
}

export default TeamArea